import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const kind = params.get("kind");
  const [status, setStatus] = useState("checking");
  const polled = useRef(false);

  useEffect(() => {
    if (!sessionId || polled.current) return;
    polled.current = true;
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setStatus("timeout"); return; }
      attempts++;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("success"); return; }
        if (data.status === "expired") { setStatus("failed"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-24 text-center">
        <div className="card-brut-lg rounded-xl p-10 bg-white fade-up" data-testid="payment-return-card">
          {status === "checking" && (
            <>
              <Loader2 size={48} className="mx-auto animate-spin text-[#D94A3D]" />
              <h1 className="font-heading font-bold text-2xl tracking-tight mt-4">Confirming payment...</h1>
              <p className="text-[#17324D]/80 mt-2">Hang tight while we activate your membership.</p>
            </>
          )}
          {status === "success" && (
            <>
              <CheckCircle2 size={48} className="mx-auto text-[#17324D]" />
              <h1 className="font-heading font-extrabold text-3xl tracking-tight mt-4">{kind === "platform" ? "You're live!" : "You're in!"}</h1>
              <p className="text-[#17324D]/80 mt-2">{kind === "platform" ? "Your platform subscription is active. Start building your club." : "Your membership is active. Start saving on every order."}</p>
              <Link to={kind === "platform" ? "/owner" : "/dashboard"} data-testid="return-dashboard-btn"
                className="inline-block mt-6 px-6 py-3 bg-[#D94A3D] text-white font-semibold border border-[#17324D]/15 rounded-xl hover:bg-[#C33E32]">
                {kind === "platform" ? "Go to Owner Dashboard" : "Go to My Dashboard"}
              </Link>
            </>
          )}
          {(status === "failed" || status === "timeout") && (
            <>
              <XCircle size={48} className="mx-auto text-[#D94A3D]" />
              <h1 className="font-heading font-bold text-2xl tracking-tight mt-4">{status === "timeout" ? "Still processing" : "Payment not completed"}</h1>
              <p className="text-[#17324D]/80 mt-2">{status === "timeout" ? "Check your dashboard shortly." : "Please try again."}</p>
              <Link to="/clubs" className="inline-block mt-6 px-6 py-3 bg-white font-semibold border border-[#17324D]/15 rounded-xl hover:bg-[#FFF4E6]">
                Back to Clubs
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
